import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";

import { Observable } from "rxjs";

import { DffedbCookieConsentSandbox } from "./dffedb-cookie-consent.sandbox";
import { DffedbCookieConsentViewModel } from "./dffedb-cookie-consent.view-model";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AsyncPipe } from "@angular/common";

@Component({
    templateUrl: "./dffedb-cookie-consent.component.html",
    styleUrls: ["./dffedb-cookie-consent.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, MatProgressSpinner, AsyncPipe]
})
export class DffedbCookieConsentComponent implements OnInit {
    public vm$: Observable<DffedbCookieConsentViewModel>;

    @Input() public version: string;
    @Input() public pageReload: boolean | string = false;

    constructor(private readonly sandbox: DffedbCookieConsentSandbox) {}

    public ngOnInit(): void {
        this.vm$ = this.sandbox.selectViewModel();
        void this.bootstrapCookieConsent();
    }

    private async bootstrapCookieConsent(): Promise<void> {
        await this.sandbox.initialize(this.version, this.pageReload);
        queueMicrotask(() => {
            if (this.sandbox.isCookieConsentUpdateNeeded()) {
                this.sandbox.showCookieConsentDialog();
            } else {
                this.sandbox.renewCookieConsent();
            }
        });
    }

    public onClick(event: Event): void {
        event.preventDefault();
        this.sandbox.showCookieConsentDialog();
    }
}
